module.exports = __webpack_public_path__ + "static/article-2-e8c6ff421354416ad31215542526103f.png";